<script>
    import Fa from 'svelte-fa';
    import * as Icons from '@fortawesome/free-solid-svg-icons';
    import * as BrandIcons from '@fortawesome/free-brands-svg-icons';
    import * as RegularIcons from '@fortawesome/free-regular-svg-icons';
    import SvelteMarkdown from 'svelte-markdown'

    export let content; // gridContent
    export let contentBgColour;
    export let contentTextColour;

    const iconData = content[0];
    const textData = content[1];

    // console.log('Content', content);
    
    // Get the icon name from element.data.icons and convert it to a FontAwesome icon
    const getIcon = (iconName) => {
        // Replace icon name kebab-case with camelCase using regex
        const iconNameCamelCase = iconName ? iconName.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); }) : '';
        // console.log(iconNameCamelCase);
        // Remove the 'fas ' from the icon name
        if (iconNameCamelCase.includes('fas ')) {
            const iconName = iconNameCamelCase.replace('fas ', '');
            // console.log(iconName);
            return Icons[iconName];
        }
        // Remove the 'fab ' from the icon name
        if (iconNameCamelCase.includes('fab ')) {
            const iconName = iconNameCamelCase.replace('fab ', '');
            // console.log(iconName);
            return BrandIcons[iconName];
        }
        // Remove the 'far ' from the icon name
        if (iconNameCamelCase.includes('far ')) {
            const iconName = iconNameCamelCase.replace('far ', '');
            // console.log(iconName);
            return RegularIcons[iconName];
        }
        return false;
    }

    const cleanMarkdown = (markdown) => {
        // Add space after series of #'s
        const cleanedMarkdown = markdown.replace(/(#+)([^#])/g, '$1 $2');
        return cleanedMarkdown;
    }

    const bgShade = (element, bgColour) => {
        if (element.bgShade == 'darken') {
            return `background-color: color-mix(in srgb, ${elBgColour(element)} 90%, black);`;
        }
        if (element.bgShade == 'lighten') {
            return `background-color: color-mix(in srgb, ${elBgColour(element)} 90%, white);`;
        }
        if (element.type == 'icon') {
            return `background-color: color-mix(in srgb, ${elBgColour(element)} 90%, black);`;
        }
        return `background-color: ${elBgColour(element)};`;
    }

    const elBgColour = (element) => {
        if (element.hasOwnProperty('bgColour') && element.bgColour ) {
            return element.bgColour;
        }
        return contentBgColour;
    
    }

</script>

<div class="card element"
    style = "background-color: color-mix(in srgb, {contentBgColour} 75%, white 20%);"
    >
    {#each content as element}
        <!-- Used for debugging background colours -->
        <!-- <ul style="{bgShade(element, contentBgColour)};">
            <li>bgColour = {element.bgColour}</li>  
            <li>bgShade = {element.bgShade}</li>
            <li>contentBgColour = {contentBgColour}</li>
            <li>bgColour() = {elBgColour(element)}</li>
        </ul> -->

        {#if element.type == 'icon'}
            <div class="element-content icon iconColor-{contentTextColour}"
                style = "{bgShade(element, contentBgColour)};"
                >
                <div class="icon-wrapper icon-{element.icon}">
                    <Fa icon={getIcon(element.icon)} class="fa-icon"/>
                </div>
            </div>
        {/if}
        {#if element.type == 'text'}
            <div class="element-content text textColor-{element.textColour}"
                style = "{bgShade(element, contentBgColour)};"
                >
                <SvelteMarkdown source={cleanMarkdown(element.text)} />
            </div>
        {/if}
        {#if element.type == 'image'}
            <div class="element-content image"
                style = "{bgShade(element, contentBgColour)};"
                >
                <img src="{element.file.url}" alt="{element.file.name}"/>
            </div>
        {/if}
    {/each}

</div>

<style>
    .card {
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .element-content {
        padding: 10px;
    }
    .element-content:first-child {
        border-radius: 5px 5px 0 0;
    }
    .element-content:last-child {
        border-radius: 0 0 5px 5px;
        flex-grow: 2;
    }
    .icon {
        text-align: center;
        font-size: 3em;
        border-radius: 5px 5px 0 0;
    }
    .text {
        color: #000000;
        word-break: break-word;
    }
    .textColor-light, .iconColor-light {
        color: #ffffff;
    }
</style>